const auth = {
    "backend": "https://official-website-production-38a3.up.railway.app",
}
export default auth;